<template>
  <div>
    <h3 class="header">Kevin Aura</h3>
    <div class="fullscreen-login">
      <div class="login-content">
        <h2 class="login-title">欢迎登录</h2>
        <form @submit.prevent="handleSubmit" class="login-form">
          <div class="form-row">
            <div class="label-input-group">
              <label for="phone">手机号：</label>
              <input
                id="phone"
                v-model="form.phone"
                type="tel"
                placeholder="请输入手机号码"
                @blur="validatePhone"
              />
            </div>
            <span class="error-msg">{{ errors.phone }}</span>
          </div>

          <div class="form-row">
            <div class="label-input-group">
              <label for="code">验证码：</label>
              <div class="code-input-group">
                <input
                  id="code"
                  v-model="form.code"
                  type="tel"
                  placeholder="请输入验证码"
                  maxlength="6"
                  @blur="validateCode"
                />
              </div>
            </div>
            <span class="error-msg">{{ errors.code }}</span>
          </div>
          <button
            type="button"
            class="send-code-btn"
            :disabled="isCountingDown"
            @click="sendVerificationCode"
          >
            {{ countdown > 0 ? `${countdown}s后重发` : "获取验证码" }}
          </button>
          <button type="submit" class="login-btn" :disabled="isSubmitting">
            {{ isSubmitting ? "登录中..." : "登录" }}
          </button>
        </form>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { send } from "@/utils/request";
import { login } from "@/utils/request";
import axios from "axios";
export default {
  name: "Login",
  data() {
    return {
      form: {
        phone: "",
        code: "",
      },
      errors: {
        phone: "",
        code: "",
      },
      isSubmitting: false,
      isCountingDown: false,
      countdown: 0,
      countdownInterval: null,
    };
  },
  methods: {
    validatePhone() {
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!this.form.phone) {
        this.errors.phone = "请输入手机号码";
        return false;
      } else if (!phoneRegex.test(this.form.phone)) {
        this.errors.phone = "请输入正确的手机号码";
        return false;
      } else {
        this.errors.phone = "";
        return true;
      }
    },
    async validateCode() {
      if (!this.form.code) {
        this.errors.code = "请输入验证码";
        return false;
      } else if (this.form.code.length < 5) {
        this.errors.code = "验证码为5位数字";
        return false;
      } else {
        this.errors.code = "";
        return true;
      }
    },
    async sendVerificationCode() {
      if (!this.validatePhone()) return;

      this.isCountingDown = true;
      this.countdown = 120;
      this.countdownInterval = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.countdownInterval);
          this.isCountingDown = false;
        }
      }, 1000);
      //获取验证码
      await send({
        data: {
          user_phone: this.form.phone,
        },
      });
      this.$toast("验证码发送成功");
    },
    async handleSubmit() {
      const isPhoneValid = this.validatePhone();
      const isCodeValid = this.validateCode();

      if (!isPhoneValid || !isCodeValid) return;

      this.isSubmitting = true;

      //用户登录
      try {
        const res = await login({
          data: {
            user_phone: this.form.phone,
            vercode: this.form.code,
          },
        });
        var user = {
          phone: res.data.data.phone,
          name: res.data.data.username,
          userImage: axios.defaults.baseURL + res.data.data.image,
        };
        // 存储登录信息
        this.$store.dispatch("user/login", {
          user,
          token: res.data.data.token,
        });
        this.isSubmitting = false;
        setTimeout(() => {
          this.$toast.success("登录成功");
          this.$router.replace("/home");
        }, 800);
      } catch (err) {
        this.isSubmitting = false;
        this.form.code = "";
      }
    },
  },
  beforeDestroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  },
};
</script>
  
  <style scoped>
.fullscreen-login {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f7fa;
  padding: 20px;
}

.login-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 40px;
  width: 100%;
  max-width: 500px;
}

.login-title {
  text-align: center;
  color: #333;
  margin-bottom: 30px;
  font-size: 24px;
  font-weight: 600;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.form-row {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.label-input-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

label {
  width: 80px;
  font-size: 15px;
  color: #666;
  font-weight: 500;
  text-align: right;
  flex-shrink: 0;
}

input {
  padding: 12px 18px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 15px;
  transition: all 0.3s;
  flex: 1;
  height: 40px;
  box-sizing: border-box;
}

input:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
  outline: none;
}

.code-input-group {
  display: flex;
  flex: 1;
  gap: 10px;
}

.send-code-btn {
  padding: 0 15px;
  background-color: transparent;
  border: none;
  border-radius: 8px;
  color: #409eff;
  font-size: 14px;
  /* cursor: pointer; */
  transition: all 0.3s;
  white-space: nowrap;
  /* height: 40px; */
  flex-shrink: 0;
  text-align: right;
}

/* .send-code-btn:hover:not(:disabled) {
  background-color: #e1e8f0;
} */

.send-code-btn:disabled {
  color: #999;
  cursor: not-allowed;
}

.login-btn {
  padding: 12px;
  background-color: #f0f2f5;
  color: #66b1ff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  /* cursor: pointer; */
  transition: all 0.3s;
  margin-top: 8px;
  width: 100%;
  height: 40px;
}

.error-msg {
  color: #f56c6c;
  font-size: 12px;
  height: 18px;
  margin-left: 90px; /* 标签宽度80px + 间距10px */
  line-height: 18px;
}

@media (max-width: 576px) {
  .label-input-group {
    align-items: flex-start;
    gap: 8px;
  }

  label {
    text-align: left;
    width: 23%;
    line-height: 44px;
  }

  .error-msg {
    margin-left: 0;
  }

  .login-content {
    padding: 30px 20px;
  }
}
</style>